const _ = require('lodash');

const apmType = {
    aliPay: -10,
    payPal: -20,
    paynet: -30,
    openpaySpei: -31,
    openpayCodi: -32,
    nihaoPayUnionPay: -40,
    nihaoPayAliPay: -41,
    nihaoPayWechatPay: -42,
    googlePayAuthNet: -50,
    googlePayCyberSource: -51,
    applePayAuthNet: -60,
    applePayCyberSource: -61,
    applePayCheckout: -62,
    klarnaCheckout: -70,
    klarnaPayments: -71,
    braintreePayPal: -80,
    nttLinePay: -90,
    pproPoli: -100,
    pproIdeal: -101,
    pproBitPay: -102,
    pproGrabPay: -103,
    pproSofort: -104,
    pproEps: -105,
    pproMultibanco: -106,
    pproTrustPay: -107,
    pproKlarna: -108,
    pproFpx: -109,
    pproSepa: -110,
    adyenRatePay: -200,
    adyenGiroPay: -201,
    adyenSepa: -202,
    adyenMobilePay: -203,
    adyenVipps: -204,
    adyenSwish: -205,
    adyenBlik: -206,
    adyenDotPay: -207,
    adyenIdeal: -208,
    adyenKlarnaPayOverTime: -209,
    adyenTrustly: -210,
    adyenSofort: -211,
    adyenPoli: -212,
    adyenKlarnaPayLater: -213,
    adyenKlarnaPayNow: -214,
    adyenAfterPay: -215,
    adyenDropIn: -250,
    coinbaseCommerce: -260,
    samsungPayCyberSource: -270
};

const apmTypeMapper = _.invert(apmType);

const unknownApmIssue = 'unknown';

function apmLabelUpdate(apm) {
    if (apm.label && apm.label !== unknownApmIssue) {
        // If we already have a label and it isn't unknown, then we are done.
        return;
    }

    try {
        const credentials = apm.credentials;
        let apmTypeValue = apm.apmType || apm.type;
        switch (apmTypeValue) {
            case apmType.aliPay:
                // userId & password & entityId
                apm.label = `...${credentials.userId.slice(-4)},${credentials.entityId}`;
                break;
            case apmType.payPal:
                // client & secret
                apm.label = `...${credentials.client.slice(-4)},...${credentials.secret.slice(-4)}`;
                break;
            case apmType.paynet:
                // public key, private key, and id
                apm.label = `...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)},...${credentials.id}`;
                break;
            case apmType.openpaySpei:
                // public key, private key, and id
                apm.label = `...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)},...${credentials.id}`;
                break;
            case apmType.openpayCodi:
                // public key, private key, and id
                apm.label = `...${credentials.publicKey.substr(-4)},...${credentials.privateKey.substr(-4)},...${credentials.id}`;
                break;
            case apmType.nihaoPayUnionPay:
                apm.label = `...${credentials.bearerToken.slice(-8)}`;
                break;
            case apmType.nihaoPayAliPay:
                apm.label = `...${credentials.bearerToken.slice(-8)}`;
                break;
            case apmType.nihaoPayWechatPay:
                apm.label = `...${credentials.bearerToken.slice(-8)}`;
                break;
            case apmType.googlePayAuthNet:
                apm.label = `...${credentials.merchantGatewayId.slice(-4)}`;
                break;
            case apmType.googlePayCyberSource:
                apm.label = `...${credentials.merchantGatewayId.slice(-4)}`;
                break;
            case apmType.applePayAuthNet:
                apm.label = `...${credentials.merchantPrivateKeyPem.slice(-4)},...${credentials.merchantCertificatePem.slice(-4)},${credentials.merchantIdentifier}`;
                break;
            case apmType.applePayCyberSource:
                apm.label = `...${credentials.merchantPrivateKeyPem.slice(-4)},...${credentials.merchantCertificatePem.slice(-4)},${credentials.merchantIdentifier}`;
                break;
            case apmType.applePayCheckout:
                apm.label = `...${credentials.checkoutGateway.slice(-4)},${credentials.merchantIdentifier}`;
                break;
            case apmType.klarnaCheckout:
            case apmType.klarnaPayments:
                apm.label = `...${credentials.username.slice(-4)},...${credentials.password.slice(-4)},...${credentials.clientId.slice(-4)}`;
                break;
            case apmType.braintreePayPal:
                apm.label = `...${credentials.merchantId.slice(-4)},...${credentials.publicKey.slice(-4)},...${credentials.privateKey.slice(-4)},...${credentials.tokenizationKey.slice(-4)}`;
                break;
            case apmType.nttLinePay:
                apm.label = `...${credentials.login.slice(-4)},...${credentials.password.slice(-4)},...${credentials.signature.slice(-4)}`;
                break;
            case apmType.pproPoli:
            case apmType.pproIdeal:
            case apmType.pproBitPay:
            case apmType.pproGrabPay:
            case apmType.pproSofort:
            case apmType.pproEps:
            case apmType.pproMultibanco:
            case apmType.pproTrustPay:
            case apmType.pproKlarna:
            case apmType.pproFpx:
            case apmType.pproSepa:
                apm.label = `...${credentials.login.slice(-4)},...${credentials.password.slice(-4)},${credentials.contractId}`;
                break;
            case apmType.adyenRatePay:
            case apmType.adyenGiroPay:
            case apmType.adyenSepa:
            case apmType.adyenSwish:
            case apmType.adyenVipps:
            case apmType.adyenMobilePay:
            case apmType.adyenBlik:
            case apmType.adyenDotPay:
            case apmType.adyenIdeal:
            case apmType.adyenKlarnaPayOverTime:
            case apmType.adyenTrustly:
            case apmType.adyenSofort:
            case apmType.adyenPoli:
            case apmType.adyenKlarnaPayLater:
            case apmType.adyenKlarnaPayNow:
            case apmType.adyenAfterPay:
            case apmType.adyenDropIn:
                apm.label = `...${credentials.clientKey.slice(-4)}`;
                break;
            case apmType.coinbaseCommerce:
                apm.label = `...${credentials.apiKey.slice(-4)}`;
                break;
            case apmType.samsungPayCyberSource:
                apm.label = `...${credentials.partnerKey.slice(-4)}`;
                break;
            default:
                apm.label = unknownApmIssue;
        }
    } catch (e) {
        console.error('APM Label Creation Error:', e);
        apm.label = unknownApmIssue;
    }
}

module.exports = {
    apmType,
    apmTypeMapper,
    apmLabelUpdate
};
